:host {
    display: flex;
    justify-content: center;

    .heading {
        &.top {

        }
        &.bottom {

        }
    }

    .maglr-bar-container {
        display: flex;
        grid-column-gap: 20px;
        grid-row-gap: 20px;

        flex-direction: column;

        &.bottom {
            flex-direction: column-reverse;
        }

        &.horizontal {
            width: 100%;

            &.left, &.right {
                grid-column-gap: 25px;
                grid-row-gap: 25px;
                flex-direction: row;
                align-items: center;

                bar-component {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                }

            }
            &.right {

                flex-direction: row-reverse;
            }

            .bar-text {
                justify-content: space-between;
                align-items: center;
                display: flex;

                &.flip {
                    flex-direction: row-reverse
                }
            }
        }

        &.vertical {
            //width: var(--bar);
            height: 100%;
            grid-column-gap: 25px;
            grid-row-gap: 25px;
            align-items: center;

            .bar-text {
                grid-column-gap: 5px;
                grid-row-gap: 5px;
                flex-direction: column;
                align-items: flex-start;
                padding-bottom: 0;
            }

            bar-component {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;

            }

            &.left, &.right  {

                flex-direction: row;
                align-items: start;

                bar-component {
                    height: 100%;
                }
            }

            &.right {
                flex-direction: row-reverse;
            }

            .bar-text.flip{
                align-self: flex-end;
            }

        }


    }
}
